import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/assert/is-boolean';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var isBoolean = __var_1__.isPrimitive;


// VARIABLES //

var debug = logger( 'plot:set:auto-view' );


// MAIN //

/**
* Sets the viewing mode.
*
* @private
* @param {boolean} bool - boolean indicating whether to generate an updated view on a render event
* @throws {TypeError} must be a boolean primitive
*/
function set( bool ) {
	/* eslint-disable no-invalid-this */
	if ( !isBoolean( bool ) ) {
		throw new TypeError( 'invalid value. `autoView` must be a boolean primitive. Value: `' + bool + '.`' );
	}
	if ( bool !== this._autoView ) {
		debug( 'Current value: %s.', this._autoView );

		this._autoView = bool;
		debug( 'New Value: %s.', this._autoView );

		this.emit( 'change' );
	}
}


// EXPORTS //
export default set;
